/**
 * React contexts for the active `Datastore` and the active language.
 *
 * Split from `datastore.tsx` so leaf hooks (`useDatastore`,
 * `useSiloLanguage`) can import the contexts without dragging in the entire
 * `Datastore` class — important for trimming bundle size in
 * platform-specific entry points. The
 * `LanguageContext` default of `'en-US'` is the fallback when no `Datastore` is
 * mounted (e.g. in early boot or in standalone component tests).
 */

import { type IsoLocale } from '@repo/shared/locale';
import React from 'react';

import type { Datastore } from './datastore';

export const DatastoreContext = React.createContext<Datastore | null>(null);
export const LanguageContext = React.createContext<IsoLocale>('en-US');

// Test-only override for whether the app is rendering in a sidebar, set by
// `SidebarContextWrapper`. The `null` default means "no override — ask the
// real environment": `useIsInSidebar` falls back to `getIsInSidebar()`, so
// it works without a Datastore mounted, e.g. during skeleton loading.
// `null` rather than `false` keeps "no override" distinct from "not in a
// sidebar", and keeps this leaf module free of a module-scope
// `platform-specific/url` call.
export const IsInSidebarContext = React.createContext<boolean | null>(null);
